import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import type { PropsWithChildren } from 'react';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import { isDarkTheme } from '#/common/utils/themeDetection';

export type DashboardProps = PropsWithChildren;

const DashboardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  h4 {
    text-transform: none;
  }
`;

const BackgroundImageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  background-color: ${color('custom', 'formBackground')};
  background-image:
    radial-gradient(at center, rgba(0, 0, 0, 0.5), rgba(1, 1, 1, 1) 87%),
    url('/dashboard-background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
`;

const DashboardContent = styled.div`
  position: relative;
  z-index: 1;
`;

const Dashboard: React.FC<DashboardProps> = ({ children }) => {
  const theme = useTheme();
  const showBackgroundImage = isDarkTheme(theme);

  return (
    <DashboardWrapper>
      {showBackgroundImage && <BackgroundImageContainer />}
      <DashboardContent>
        <NuvoGrid container>{children}</NuvoGrid>
      </DashboardContent>
    </DashboardWrapper>
  );
};

export default React.memo(Dashboard);
